// src/utils/validation.js

export const validateTransferData = (data) => {
  const errors = {};

  if (!data.date) errors.date = "Date is required";
  if (!data.amount) errors.amount = "Amount is required";
  if (!data.sourcePaymentMethod)
    errors.sourcePaymentMethod = "Source Payment Method is required";
  if (!data.destinationPaymentMethod)
    errors.destinationPaymentMethod = "Destination Payment Method is required";

  return errors;
};
